import React, { useEffect, useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useNavigate, useLocation, useParams } from "react-router-dom"; // Import useLocation here
import axiosInstance from "../../Services/axios";
import "./LoyaltyOffer.css";
import pingleUserIcon from "../../Assets/Images/Pingle _UserCoin.png";
import placeholderImage from "../../Assets/Images/default-placeholder.png";
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import loyaltydefalty from '../../Assets/Images/Loyaltydefalty.png'
import NodeaxiosInstance from "../../Services/nodeaxios";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import { getUserVendorLoyaltyDetails } from "../../Services/api";

const MerchantLoyalty = () => {
  const valueParam = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { vendorId } = location.state || {};
  const [loyaltyData, setLoyaltyData] = useState({});


  useEffect(() => {
    getLoyaltyOffers();
  }, []);

  const getLoyaltyOffers = async () => {
    try {
      let reqData = {
        vendor_id: valueParam.vendorId,
      };
      let res = await getUserVendorLoyaltyDetails(reqData);
      if (res?.status == 200) {
        let data = res.data;
        console.log(data);

        setLoyaltyData(data);
      }
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response.data.message || "Something went wrong. Please try again.");
      }
    }
  };

  const setLoyaltyDetail = (offerid,) => {
    let loyaltyDetail = { 'offerId': offerid, 'vendorid': valueParam.vendorId }
    localStorage.setItem('loyaltyDetail', JSON.stringify(loyaltyDetail));
    navigate(`/singleLoyaltydetails/${valueParam.vendorId}/${offerid}`);


  }
  return (
    <div className="merchantLoyaltyPage">
      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img
            src={p_nav_previous}
            width={"24px"}
            height={"16px"}
            alt="Previous Button"
            role="button"
            onClick={() => navigate(-1)}
          />
          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1"> Loyalty Offers</div>
        </div>
      </div>

      <div className="p-2 merchantLoyaltyContent">
        <div className="ms-3">
          <p className="ff-poppins-bold fs-20 secondary-text m-0">{loyaltyData?.vendor_name} Offer {loyaltyData?.vendor_unlock_offers > 1 ? 's' : ''}  </p>

        </div>
        <div className="merchantLoyaltyList">
          <div className="pingleOfferHero mt-2" id="availbleofferid">
            {
              loyaltyData?.vendor_unlock_offers_count == 0 && loyaltyData?.vendor_eligble_offers_count == 0 ?
                <div className="d-flex justify-content-center align-items-center">
                  <div className="text-center align-self-center">
                    <Lottie animationData={empotyLottie} />
                    <div className="fs-14 ff-poppins-semiBold">No Offers available</div>
                  </div>
                </div>
                :
                <>
                  {
                    loyaltyData.vendor_eligble_offers?.length > 0 &&
                    <div className="" id="availbleofferid">
                      <div className="pinglerOfferItemsCardsDiv">
                        <div className="fw-bold pb-3 fs-5">
                          {loyaltyData.vendor_eligble_offers_count} Offers for You!
                        </div>
                        <div className="row gx-0 px-0">
                          {loyaltyData?.vendor_eligble_offers?.map((offers, index) => (

                            <div className="col-6 px-1 mt-2 cardposition-relative" key={index}>
                              <div className="pingleOfferCardBox d-flex flex-column h-100 mx-1">
                                <div className="offer-content d-flex flex-column  flex-grow-1 justify-content-between text-center p-2">
                                  <div className="offer-image-wrapper">
                                    <img src={offers.offer_images.length > 0 ? offers.offer_images[0] : placeholderImage}
                                      onError={(event) => {
                                        event.target.onerror = null;
                                        event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg';
                                      }}
                                      alt="Offer" className="pingleOfferImage"
                                    />
                                  </div>
                                  <div>
                                    <div className="d-flex justify-content-center align-items-center ">
                                      <div className="d-flex justify-content-around align-items-center coinPingleBox pingleOfferPointsDiv primary-bg">
                                        <img src={pingleUserIcon} className="PingleLoyaltyIcon " style={{ width: 20, height: 20, }} alt="PLIcon" />
                                        <p className="m-0 ff-poppins-semiBold text-white  d-flex align-item-center fs-11">{offers?.offer_points}</p>
                                      </div>
                                    </div>



                                    <div className="offer-description mt-3 mb-2">
                                      <p className="fs-14 text-dark ff-poppins-semiBold mt-2"> {offers?.offer_name}  </p>
                                      <p className="fs-11 ff-poppins-regular" > {offers?.offer_discription?.length > 60 ?
                                        `${offers?.offer_discription.slice(0, 60)}...` : offers?.offer_discription}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-center">
                                    <button className=" pingleOfferRedeemBtnGreen  primary-bg" onClick={() => setLoyaltyDetail(offers.offer_id)}>
                                      REDEEM
                                    </button>
                                  </div>
                                </div>

                              </div>
                            </div>


                            // <div className="col-6 px-1 cardposition-relative" key={index}>
                            //   <div className="col-12 d-flex flex-column mx-1 pingleOfferCardBox">


                            //     <div className="text-center ">
                            //        <div className="offer-image-wrappercol-6 px-0 w-100">
                            //       <img src={offers.offer_images.length > 0 ? offers.offer_images[0] : placeholderImage}
                            //         onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg' }}
                            //         alt={offers.offer_images.length > 0 ? "Offer Image" : "No Offer Image"}
                            //         className="pingleOfferImage"
                            //       />
                            //     </div> 

                            //       <div className="d-flex justify-content-center align-item-center ">
                            //         <div className="d-flex justify-content-around pingleOfferPointsDiv col-6 primary-bg p-1">
                            //           <img src={pingleUserIcon} className="PingleLoyaltyIcon " style={{ width: 20, height: 20, }} alt="PLIcon" />
                            //           <p className="m-0 ff-poppins-semiBold text-white  d-flex align-item-center fs-11">{offers?.offer_points}</p>
                            //         </div>
                            //       </div>
                            //       <div className="p-1">
                            //         <div className="mt-3 mb-1">
                            //           <p className="fs-14 text-dark ff-poppins-semiBold"> {offers?.offer_name}  </p>
                            //           <p className="fs-12 ff-poppins-regular" > {offers?.offer_discription?.length > 60 ?
                            //             `${offers?.offer_discription.slice(0, 60)}...` : offers?.offer_discription}
                            //           </p>
                            //         </div>
                            //       </div>


                            //       <button className=" pingleOfferRedeemBtnGreen  primary-bg" onClick={() => setLoyaltyDetail(offers.offer_id)}>
                            //         REDEEM
                            //       </button>
                            //     </div>
                            //   </div>
                            // </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  }
                  {
                    loyaltyData?.vendor_unlock_offers?.length > 0 ?
                      <div className="pingleOfferHero" id="availbleofferid">
                        <div className="pinglerOfferItemsCardsDiv">
                          <div className="row gx-0 px-0">
                            <div className="ff-poppins-bold fs-16 pb-2">
                              {loyaltyData?.vendor_unlock_offers_count} Offers available to unlock
                            </div>
                            <div className="row gx-0 px-0">
                              {loyaltyData?.vendor_unlock_offers && loyaltyData?.vendor_unlock_offers.map((offers, index) => (

                                // <div className="col-6 px-1 mt-2 pingleOfferCardBox" key={index}>
                                //   <div className=" d-flex flex-column mx-1  ">

                                //     <div className="col-6 px-0 w-100">
                                //       <img src={offers.offer_images.length > 0 ? offers.offer_images[0] : placeholderImage}
                                //         onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg' }}
                                //         alt="No Offer Images"
                                //         className="pingleOfferImage"
                                //       />
                                //     </div>

                                //     <div className="text-center ">
                                //       <div className="d-flex justify-content-center align-item-center ">
                                //         <div className="d-flex justify-content-around pingleOfferPointsDiv col-6 primary-bg p-1">
                                //           <img src={pingleUserIcon} className="PingleLoyaltyIcon " style={{ width: 20, height: 20, }} alt="PLIcon" />
                                //           <p className="m-0 ff-poppins-semiBold text-white  d-flex align-item-center fs-11">{offers?.offer_points}</p>
                                //         </div>
                                //       </div>
                                //       <div className="p-1">
                                //         <div className="mt-3 mb-1 offer-description">
                                //           <span className="ff-poppins-bold">   {offers?.offer_name}  </span>
                                //           <p className="fs-12 ff-poppins-regular">
                                //             {offers?.offer_discription?.length > 60
                                //               ? `${offers.offer_discription.substring(0, 60)}...`
                                //               : offers?.offer_discription}
                                //           </p>

                                //         </div>
                                //       </div>
                                //       <button className=" pingleOfferRedeemBtnGreen secondary-btn-disable" >
                                //         REDEEM
                                //       </button>
                                //     </div>
                                //   </div>
                                // </div>

                                <div className="col-6 px-1 mt-2 cardposition-relative" key={index}>
                                  <div className="pingleOfferCardBox d-flex flex-column h-100 mx-1">
                                    <div className="offer-content d-flex flex-column  flex-grow-1 justify-content-between text-center p-2">
                                      <div className="offer-image-wrapper">
                                        <img
                                          src={offers.offer_images.length > 0 ? offers.offer_images[0] : placeholderImage}
                                          onError={(event) => {
                                            event.target.onerror = null;
                                            event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg';
                                          }}
                                          alt="Offer" className="pingleOfferImage"
                                        />
                                      </div>
                                      <div>

                                        <div className="d-flex justify-content-center align-items-center ">
                                          <div className="d-flex justify-content-around align-items-center coinPingleBox pingleOfferPointsDiv primary-bg">
                                            <img src={pingleUserIcon} className="PingleLoyaltyIcon" style={{ width: 20, height: 20 }} alt="PLIcon" />
                                            <p className="m-0 ff-poppins-semiBold text-white ms-1 fs-11">  {offers?.offer_points}  </p>
                                          </div>
                                        </div>

                                        <div className="offer-description mt-3 mb-2">
                                          <span className="ff-poppins-bold">{offers?.offer_name}</span>
                                          <p className="fs-12 ff-poppins-regular">
                                            {offers?.offer_discription
                                              ? (offers.offer_discription.length > 60
                                                ? `${offers.offer_discription.substring(0, 60)}...`
                                                : offers.offer_discription)
                                              : ''}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="d-flex justify-content-center">
                                        <button className="pingleOfferRedeemBtnGreen secondary-btn-disable mt-auto">
                                          REDEEM
                                        </button>
                                      </div>
                                    </div>

                                  </div>
                                </div>


                              ))}
                            </div>
                          </div>
                        </div>
                      </div> :
                      <> </>
                    // <div>
                    //   <Lottie animationData={empotyLottie} />
                    //   <div>0 Item to unlock </div>
                    // </div>
                  }

                </>
            }






          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantLoyalty;
